/**
 * Product Registration Application
 * Main entry point for the product registration form
 */
(function() {
    'use strict';

    /**
     * Application initialization
     */
    class ProductRegistrationApp {
        constructor(customerId, apiEndpoints) {
            this.customerId = customerId;
            this.apiEndpoints = apiEndpoints;
            this.validator = new FieldValidator();
            this.fileUploadManager = new FileUploadManager(this.validator);
            this.formController = new MultiStepFormController(
                this.validator,
                this.apiEndpoints,
                this.customerId
            );
        }

        initialize() {
            // Idempotent guard: a second boot for the same form would bind a duplicate
            // submit listener and fire two requests with one token. Flag is form-scoped.
            const form = document.getElementById('product-registration-form');
            if (!form) return;
            if (form.dataset.registrationInitialized === 'true') return;
            form.dataset.registrationInitialized = 'true';

            this.fileUploadManager.initialize();
            this.formController.initialize();
        }
    }

    // Export to global scope for initialization from Liquid template
    window.ProductRegistrationApp = ProductRegistrationApp;

})();

